module.exports = __webpack_public_path__ + "static/hero-a0db72fc315a8f83771445e49031031c.png";